"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var operators_1 = require("rxjs/operators");
var of_1 = require("rxjs/observable/of");
var DisaggregationUtil = /** @class */ (function () {
    function DisaggregationUtil() {
    }
    /**
     * Check name exist in classifier
     * @param {number} languageId
     * @param {string} name
     * @param {Classifier} classifier
     * @returns {boolean}
     */
    DisaggregationUtil.equalsNames = function (languageId, name, classifier) {
        if (classifier.getMultilingualName().getValue(languageId) == name) {
            return true;
        }
        return false;
    };
    /**
     * Check name exist in classifier array
     * @param {number} languageId
     * @param {string} name
     * @param {Observable<Array<Classifier>>} observableArray
     * @returns {Observable<boolean>}
     */
    DisaggregationUtil.alreadyExistClassifier = function (languageId, name, observableArray) {
        var _this = this;
        return observableArray.pipe(operators_1.switchMap(function (res) {
            for (var _i = 0, res_1 = res; _i < res_1.length; _i++) {
                var classifier = res_1[_i];
                if (_this.equalsNames(languageId, name, classifier)) {
                    return of_1.of(true);
                }
            }
            return of_1.of(false);
        }));
    };
    DisaggregationUtil.createClassifierDummy = function (id, name) {
        var properties = new Map();
        properties.set("name", new idm_de_core_frontend_1.PropertyValueAccessor(name));
        properties.set("id", new idm_de_core_frontend_1.PropertyValueAccessor(id));
        return new idm_classifier_service_client_js_1.ClassifierView(properties);
    };
    return DisaggregationUtil;
}());
exports.DisaggregationUtil = DisaggregationUtil;
//# sourceMappingURL=disaggregation.util.js.map